<div id="<%= dom_id question %>" class="w-full sm:w-auto my-5 space-y-5">
  <div>
    <strong class="block font-medium mb-1">Billable:</strong>
    <%= question.billable_id %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Question text:</strong>
    <%= question.question_text %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Question type:</strong>
    <%= question.question_type %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Choices:</strong>
    <%= question.choices %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Order:</strong>
    <%= question.order %>
  </div>
</div>
